import { createFileRoute } from "@tanstack/react-router";

import { InvoicesTab } from "@/features/wonda/components/InvoicesTab";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/invoices",
)({
  component: InvoicesTab,
});
